import React from "react";
import { Link } from "react-router-dom";

import {
  FiArrowUpRight,
  FiArrowRight,
  FiMail,
  FiMapPin,
  FiPhone,
  FiLinkedin,
  FiTwitter,
  FiGithub,
  FiInstagram,
  FiCpu,
  FiZap,
  FiMessageSquare,
  FiShoppingBag,
  FiHeart,
  FiTruck,
  FiBriefcase,
  FiChevronDown,
} from "react-icons/fi";

import "../Footer.css";
import logo from "../../assets/dropgear-favicon.png";


const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">

      {/* ========================= CTA ========================= */}
      <section className="footer-cta">
        <div className="footer-container">

          <div className="footer-cta-content">

            <div className="footer-cta-text">
              <span className="footer-eyebrow">
                BUILD WITH INTELLIGENCE
              </span>

              <h2>
                Ready to build
                <br />
                <span>what's next?</span>
              </h2>

              <p>
                Let's create intelligent software, AI agents,
                and SaaS systems designed for the future.
              </p>
            </div>

            <div className="footer-cta-action">

              <a
                href="/book-demo"
                className="footer-cta-button"
              >
                Book a Demo
                <FiArrowRight />
              </a>

              <a
                href="/contact"
                className="footer-cta-secondary"
              >
                Talk to our team
                <FiArrowUpRight />
              </a>

            </div>

          </div>

        </div>
      </section>


      {/* ========================= MAIN FOOTER ========================= */}
      <div className="footer-main">

        <div className="footer-container">

          <div className="footer-grid">

            {/* ================= BRAND ================= */}
            <div className="footer-brand">

              <a
                href="/"
                className="footer-logo"
              >
                <div className="footer-logo-symbol">
                  <img src={logo} alt="dropgear" />
                </div>

                <div className="footer-logo-text">
                  <span>
                    Dropgear<span> Io</span>
                  </span>


                </div>
              </a>

              <p className="footer-description">
                Dropgear IO Private Limited builds AI-powered
                SaaS products, intelligent automation systems,
                and AI agents designed to help businesses
                work smarter and scale faster.
              </p>



            </div>


            {/* ================= SOLUTIONS ================= */}
            <div className="footer-column">

              <h3>
                Solutions
                <FiChevronDown />
              </h3>

              <div className="footer-links">

                <a href="/ai-solutions">
                  <FiCpu />
                  AI Solutions
                </a>

                <a href="/ai-automation">
                  <FiZap />
                  AI Automation
                </a>

                <a href="/ai-agents">
                  <FiMessageSquare />
                  AI Agents
                </a>

                

              </div>

            </div>


            {/* ================= INDUSTRIES ================= */}
            <div className="footer-column">

              <h3>
                Industries
                <FiChevronDown />
              </h3>

              <div className="footer-links">

                <a href="/retail">
                  <FiShoppingBag />
                  Retail & E-commerce
                </a>

                <a href="/healthcare">
                  <FiHeart />
                  Healthcare
                </a>

                <a href="/logistics">
                  <FiTruck />
                  Logistics
                </a>

                <a href="/finance">
                  <FiBriefcase />
                  Finance
                </a>

                <a href="enterprise">
                  <FiCpu />
                  Enterprise
                </a>

              </div>

            </div>


            {/* ================= COMPANY ================= */}
            <div className="footer-column">

              <h3>
                Company
                <FiChevronDown />
              </h3>

              <div className="footer-links">

                {/* <Link to="/about">
                  About Us
                </Link> */}

                <a href="/how-it-works">
                  How It Works
                </a>
                <a href="/book-demo">
                  Book a Demo
                </a>


                <a href="/contact">
                  Contact
                </a>

                <a href="/login">
                  Login
                </a>

              </div>

            </div>

          </div>


          {/* ================= CONTACT STRIP ================= */}
          <div className="footer-contact-strip">

            <div className="footer-contact-item">

              <div className="footer-contact-icon">
                <FiMail />
              </div>

              <div>
                <span>Email</span>

                <a href="mailto:admin@aidropgerio.in">
                  admin@aidropgerio.in
                </a>
              </div>

            </div>


            <div className="footer-contact-item">

              <div className="footer-contact-icon">
                <FiPhone />
              </div>

              <div>
                <span>Phone</span>

                <a href="tel:+919079768125">
                  +91 9079768125
                </a>
              </div>

            </div>


            <div className="footer-contact-item">

              <div className="footer-contact-icon">
                <FiMapPin />
              </div>

              <div>
                <span>Address</span>

                <p>T/604, Aarohi Crest Aprt, Nr. arohi Elegance, Bopal, Daskroi, Ahmedabad, Gujrat, India, 380058</p>
              </div>

            </div>


            <a
              href="/contact"
              className="footer-contact-link"
            >
              Contact Us
              <FiArrowUpRight />
            </a>

          </div>


          {/* ================= BOTTOM ================= */}
          <div className="footer-bottom">

            <div className="footer-copyright">
              © {currentYear} Dropgear IO Private Limited.
              All rights reserved.
            </div>

            <div className="footer-legal">

              <a href="/privacy-policy">
                Privacy Policy
              </a>

              <span></span>

              <a href="/terms-conditions">
                Terms of Service
              </a>

              <span></span>

            </div>

          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;